export default __webpack_public_path__ + "static/media/bloc_blanc.91ed89f6.png";